module.exports = __webpack_public_path__ + "img/logo-secondary@2x.27afc1ab.png";